import React from 'react';
import { Table, InputNumber, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export default function ServiceTable({ lineItems, handleQtyChange, handleRemoveItem, handlePriceChange, firstColumnTitle = 'Layanan' }) {
    const columns = [
        {
            title: firstColumnTitle,
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div>
                    <div>{text}</div>
                    {record.description && (
                        <div style={{ fontSize: '11px', color: '#888' }}>{record.description}</div>
                    )}
                </div>
            ),
        },
        {
            title: 'Jumlah',
            dataIndex: 'qty',
            key: 'qty',
            width: 150,
            render: (qty, record, index) => (
                <InputNumber
                    value={qty}
                    onChange={(value) => handleQtyChange(index, value)}
                    min={1}
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            title: 'Harga Satuan',
            dataIndex: 'price',
            key: 'price',
            // width: 200,
            align: 'right',
            render: (price, record, index) => {
                if (record.isEditable && handlePriceChange) {
                    return (
                        <InputNumber
                            value={price}
                            onChange={(val) => handlePriceChange(index, val)}
                            formatter={value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/Rp\s?|(,*)/g, '')}
                            style={{ width: '100%' }}
                        />
                    );
                }
                return `Rp ${Number(price).toLocaleString()}`;
            },
        },
        {
            title: 'Harga Sebelum Pajak',
            dataIndex: 'amountBeforeTax',
            key: 'amountBeforeTax',
            // width: 200,
            align: 'right',
            render: (amountBeforeTax) => amountBeforeTax != null ? `Rp ${Number(amountBeforeTax).toLocaleString()}` : '-'
        },
        {
            title: 'Tax Rate (%)',
            dataIndex: 'taxRate',
            key: 'taxRate',
            // width: 200,
            align: 'right',
            render: (taxRate) => taxRate != null ? `${taxRate}%` : '-'
        },
        {
            title: 'Jumlah Pajak',
            dataIndex: 'taxAmount',
            key: 'taxAmount',
            // width: 200,
            align: 'right',
            render: (taxAmount) => taxAmount != null ? `Rp ${Number(taxAmount).toLocaleString()}` : '-'
        },
        {
            title: 'Subtotal',
            dataIndex: 'total',
            key: 'total',
            // width: 200,
            align: 'right',
            render: (total) => `Rp ${Number(total).toLocaleString()}`,
        },
        {
            title: '',
            key: 'action',
            width: 50,
            render: (text, record, index) => (
                <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleRemoveItem(index)}
                />
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={lineItems}
            rowKey={(record, index) => index}
            pagination={false}
            locale={{
                emptyText: 'Belum ada layanan dipilih',
            }}
            size="small"
            bordered
        />
    );
}
